import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default function BaseTextLink({ children, target, ...restProps }) {
  if (restProps.href) {
    return (
      <a {...restProps} target={target} rel="noopener noreferer">
        {children}
      </a>
    );
  }
  return <Link {...restProps}>{children}</Link>;
}

BaseTextLink.defaultProps = {
  target: '_blank',
};

BaseTextLink.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/app/ui/core/common/BaseTextLink.js